import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DataInterop } from "@silvertours/front-shared";
var ProductData = function(param) {
    var products = param.products;
    var ref;
    if (!products || !((ref = products.aggregateRating) === null || ref === void 0 ? void 0 : ref.reviewCount)) {
        return null;
    }
    var aggregateRating = _object_spread_props(_object_spread({}, products.aggregateRating), {
        "@type": "AggregateRating",
        worstRating: 1,
        bestRating: 5
    });
    var data = _object_spread({
        brand: products === null || products === void 0 ? void 0 : products.brand,
        name: products === null || products === void 0 ? void 0 : products.name
    }, aggregateRating && {
        aggregateRating: aggregateRating
    });
    return products ? /*#__PURE__*/ _jsx(DataInterop.StructuredData, {
        includeContext: true,
        type: "Product",
        data: data
    }) : null;
};
export { ProductData };
